export default __webpack_public_path__ + "static/media/lock.6e9f6c3f.svg";